/**
 * CMS Editor Defaults
 * 
 * These defaults are ONLY used in the CMS admin interface to initialize
 * form fields when creating new content. They are NOT used as fallbacks
 * for the public-facing site.
 * 
 * The public site requires all content to be configured in Firestore CMS.
 */

export const cmsEditorDefaults = {
  brandName: 'Your Brand',
  brandTagline: 'Your tagline here',
  logoUrl: '',
  faviconUrl: '',
  primaryColor: '#1e40af',
  secondaryColor: '#0d9488',
  fontFamily: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif",
  contact: {
    email: '',
    phones: [],
    address: {
      street: '',
      area: '',
      city: '',
      province: '',
      country: '',
      postalCode: '',
      formatted: ''
    }
  },
  typography: {
    primaryFont: 'Inter',
    secondaryFont: 'Inter',
    headingWeight: '700',
    bodyWeight: '400',
    baseFontSize: '16',
    lineHeight: '1.6',
    letterSpacing: '0'
  },
  topbar: {
    enabled: false,
    text: '',
    linkLabel: '',
    linkHref: '',
    bgColor: '#1e40af',
    textColor: '#ffffff'
  },
  header: {
    logoDefault: '',
    logoSticky: '',
    logoTransparent: '',
    logoMobile: '',
    logoLight: '',
    isTransparent: false,
    transparentBgColor: 'rgba(0,0,0,0)',
    bgColor: '#ffffff',
    bgColorScrolled: '#ffffff',
    textColor: '#0f172a',
    textColorScrolled: '#0f172a',
    height: '64',
    heightScrolled: '56',
    sticky: true,
    scrollThreshold: 50,
    showShadowOnScroll: true,
    mobileBreakpoint: '768',
    linkColor: '#334155',
    linkHoverColor: '#1e40af',
    linkActiveColor: '#1e40af',
    borderEnabled: true,
    borderColor: '#e2e8f0',
    borderWidth: '1',
    font: '',
    navFontSize: '14',
    navFontWeight: '500',
    navLetterSpacing: '0',
    navTextTransform: 'none',
    buttonFontSize: '14',
    buttonFontWeight: '500',
    buttonTextTransform: 'none',
    actions: [
      {
        id: 'login',
        type: 'link',
        label: 'Login',
        href: '/login',
        variant: 'ghost',
        showLabel: true,
        className: 'hidden sm:block'
      },
      {
        id: 'demo',
        type: 'link',
        label: 'Book Demo',
        href: '/demo',
        variant: 'ghost',
        showLabel: true,
        className: 'hidden lg:block'
      },
      {
        id: 'trial',
        type: 'link',
        label: 'Start Free Trial',
        href: '/signup',
        variant: 'primary',
        showLabel: true
      }
    ],
    mobileMenu: {
      position: 'right',
      width: '320',
      bgColor: '#ffffff',
      textColor: '#0f172a',
      overlayColor: 'rgba(0, 0, 0, 0.5)',
      overlayBlur: true,
      showLogo: true,
      showCloseButton: true,
      closeButtonPosition: 'right',
      animation: 'slide',
      animationDuration: '300',
      linkStyle: 'default',
      linkSpacing: '16',
      linkFontSize: '16',
      linkFontWeight: '500',
      showDividers: true,
      dividerColor: '#e2e8f0',
      buttonLayout: 'stacked',
      buttonSpacing: '12',
      headerHeight: '64',
      footerText: '',
      hamburgerStyle: 'default',
      hamburgerSize: '24',
      hamburgerLineWidth: '2',
    }
  },
  buttonStyles: {
    primaryBg: '#1e40af',
    primaryText: '#ffffff',
    primaryHoverBg: '#1e3a8a',
    secondaryBg: '#ffffff',
    secondaryText: '#1e40af',
    secondaryBorder: '#1e40af',
    borderRadius: '8',
    paddingX: '24',
    paddingY: '12'
  },
  footer: {
    bgColor: '#0f172a',
    textColor: '#f8fafc',
    headingColor: '#ffffff',
    linkColor: '#94a3b8',
    linkHoverColor: '#1e40af',
    columns: '4',
    layout: 'standard',
    showLogo: true,
    showTagline: true,
    showSocial: true,
    showTrustBadges: true,
    copyrightText: '© {year} {brandName}. All rights reserved.',
    backgroundImage: '',
    backgroundOverlay: 'rgba(15,23,42,0.95)',
    socialLinks: [],
    widgets: [],
    showPoweredBy: false,
    poweredByText: '',
    poweredByLink: '',
    poweredByLogoDarkUrl: '',
    poweredByLogoDarkHoverUrl: '',
    poweredByLogoLightUrl: '',
    poweredByLogoLightHoverUrl: '',
  },
  mainNavLinks: [
    { id: 'features', label: 'Features', href: '/features', children: [] },
    { id: 'standards', label: 'Standards', href: '/standards', children: [] },
    { id: 'resources', label: 'Resources', href: '/resources', children: [] },
    { id: 'pricing', label: 'Pricing', href: '/pricing', children: [] },
    { id: 'about', label: 'About', href: '/about', children: [] },
    { id: 'contact', label: 'Contact', href: '/contact', children: [] }
  ],
  footerLinks: [
    { id: 'features', section: 'Platform', label: 'Features', href: '/features' },
    { id: 'pricing', section: 'Platform', label: 'Pricing', href: '/pricing' },
    { id: 'about', section: 'Company', label: 'About Us', href: '/about' },
    { id: 'contact', section: 'Company', label: 'Contact', href: '/contact' }
  ]
};

